// Your existing imports
import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts.css";
import "./index.css";
import "./variables.css";
import App from "./App";
import store from "./store/Store";
import { Provider } from "react-redux";
import { changeTheme } from "./store/slices/ApplicationSlice";
import { appThemeEnum } from "./classes/enums/AppThemeEnum";
import { AppProvider } from "./classes/contexts/AppContext";
import { BrowserRouter } from "react-router-dom";

// Load IndexedDB debug utilities (available in console as window.debugIndexedDB)
import "./utils/debugIndexedDB";

const root = ReactDOM.createRoot(document.getElementById("root"));
const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
store.dispatch(
  changeTheme(defaultDark ? appThemeEnum.Dark : appThemeEnum.Light)
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
